import { CircleDollarSign } from "lucide-react";
import { ReferralCommissionItem } from "../../../../Redux/referral/types";
import {
  formatEarningsCurrency,
  formatEarningsDate,
  mapReferralIncentiveItem,
  normalizeEarningsStatus,
  statusLabel,
} from "../earningsAdapters";

interface Props {
  data: ReferralCommissionItem[];
}

const renderStatus = (status: string) => (
  <span
    className={`referral-status referral-status-${normalizeEarningsStatus(status)}`}
  >
    {statusLabel(status)}
  </span>
);

const ReferralIncentiveTable = ({ data }: Props) => {
  const rows = (data || []).map(mapReferralIncentiveItem);

  return (
    <div className="referral-table-card">
      <div className="referral-mobile-scroll-hint">
        Swipe horizontally to view all columns
      </div>
      <div className="referral-table-scroll">
        <table className="referral-table">
          <thead>
            <tr>
              <th>S.NO</th>
              <th>DATE</th>
              <th>PARTNER NETWORK ID</th>
              <th>PARTNER NETWORK NAME</th>
              <th>RECEIVED INCENTIVES</th>
              <th>TDS</th>
              <th>NET AMOUNT</th>
              <th>STATUS</th>
            </tr>
          </thead>
          <tbody>
            {rows.length > 0 ? (
              rows.map((record) => (
                <tr key={record.id}>
                  <td className="referral-serial-cell">
                    <span className="referral-mobile-label">S.NO</span>
                    <strong>{record.serialNo}</strong>
                  </td>
                  <td>
                    <span className="referral-mobile-label">DATE</span>
                    <strong className="referral-date-value">
                      {formatEarningsDate(record.date)}
                    </strong>
                  </td>
                  <td>
                    <span className="referral-mobile-label">
                      PARTNER NETWORK ID
                    </span>
                    <strong className="referral-id-value">
                      {record.partnerNetworkId}
                    </strong>
                  </td>
                  <td>
                    <span className="referral-mobile-label">
                      PARTNER NETWORK NAME
                    </span>
                    <div className="referral-name">
                      <span>
                        {record.partnerNetworkName.charAt(0).toUpperCase()}
                      </span>
                      <strong>{record.partnerNetworkName}</strong>
                    </div>
                  </td>
                  <td>
                    <span className="referral-mobile-label">
                      RECEIVED INCENTIVES
                    </span>
                    <div className="referral-amount">
                      <CircleDollarSign size={17} strokeWidth={2} />
                      <strong>
                        {formatEarningsCurrency(record.grossAmount || record.receivedIncentive)}
                      </strong>
                    </div>
                  </td>
                  <td>
                    <span className="referral-mobile-label">TDS</span>
                    <strong>
                      {formatEarningsCurrency(record.tdsAmount ?? 0)}
                      {record.tdsIsEstimated ? " (est)" : ""}
                    </strong>
                  </td>
                  <td>
                    <span className="referral-mobile-label">NET AMOUNT</span>
                    <strong>
                      {formatEarningsCurrency(record.netAmount ?? record.receivedIncentive)}
                    </strong>
                  </td>
                  <td className="referral-status-cell">
                    <span className="referral-mobile-label">STATUS</span>
                    {renderStatus(record.status)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="referral-empty" colSpan={8}>
                  No referral incentive records found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReferralIncentiveTable;
